import SUIContext from '@s-ui/react-context'

import Component from './component.js'

export default SUIContext.wrapper(Component, 'ErrorMessage')
